package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.model.UnassignTicketResult
import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class UnassignTicketUseCase(
    private val repo: TicketsRepository
) {
    suspend operator fun invoke(ticketId: String): UnassignTicketResult = repo.unassignTicket(ticketId)
}
